<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        企业基础信息
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="表格列设置"
            icon="e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            v-if="operationSuper.导出"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <!--<el-form-item>-->
          <!--<el-select-->
          <!--v-model="slotForms.forms.provinceId"-->
          <!--placeholder="所属省"-->
          <!--@change="provinceChange"-->
          <!--clearable-->
          <!--filterable-->
          <!--&gt;-->
          <!--<el-option-->
          <!--v-for="item in provinceList"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.id"-->
          <!--&gt;</el-option>-->
          <!--</el-select>-->
          <!--</el-form-item>-->

          <!--<el-form-item>-->
          <!--<el-select-->
          <!--v-model="slotForms.forms.cityId"-->
          <!--placeholder="所属市"-->
          <!--@change="cityChange"-->
          <!--clearable-->
          <!--filterable-->
          <!--&gt;-->
          <!--<el-option-->
          <!--v-for="item in cityList"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.id"-->
          <!--&gt;</el-option>-->
          <!--</el-select>-->
          <!--</el-form-item>-->

          <!--<el-form-item>-->
          <!--<el-select-->
          <!--v-model="slotForms.forms.countyName"-->
          <!--placeholder="所属区县"-->
          <!--clearable-->
          <!--filterable-->
          <!--&gt;-->
          <!--<el-option-->
          <!--v-for="item in countyList"-->
          <!--:key="item.id"-->
          <!--:label="item.name"-->
          <!--:value="item.name"-->
          <!--&gt;</el-option>-->
          <!--</el-select>-->
          <!--</el-form-item>-->
          <el-form-item prop="forms.regisAreas">
            <e6-city
              ref="e6City"
              :placeholder="$GLOBAL_CONFIG.e6City.placeholder"
              class="e6-city"
              @selected="citySelect"
            ></e6-city>
          </el-form-item>
          <el-form-item prop="forms.comparyName">
            <el-input
              v-model="slotForms.forms.comparyName"
              placeholder="企业名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="forms.userTypeList">
            <e6-vr-select
              :data="roleAttributeList"
              ref="select"
              v-model="slotForms.forms.userTypeList"
              :search="false"
              placeholder="角色属性"
              multiple
              isStrict
              allow-create
            >
            </e6-vr-select>
          </el-form-item>
          <el-form-item prop="forms.corpCategoryList">
            <e6-vr-select
              :data="corpCategoryList"
              ref="select"
              v-model="slotForms.forms.corpCategoryList"
              :search="false"
              :props="{ id: 'dicId', label: 'dicName', disabled: 'disabled' }"
              placeholder="企业类别"
              multiple
              isStrict
              allow-create
            >
            </e6-vr-select>
          </el-form-item>
          <!--<el-form-item prop="forms.comparyTypeId">-->
          <!--<dict-select-->
          <!--v-model="slotForms.forms.comparyTypeId"-->
          <!--placeholder="企业类别"-->
          <!--:pkey="'corp_category'"-->
          <!--&gt;</dict-select>-->
          <!--</el-form-item>-->
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格tab end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          label="序号"
          width="80"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="index"
          :show-overflow-tooltip="true"
          min-width="130"
          align="center"
          :prop="item.name"
          :label="item.title"
        ></el-table-column>
        <el-table-column align="center" fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <router-link
              v-if="operationSuper.详情"
              :to="{
                path: '/baseComparyDetailInfo',
                query: { id: scope.row.comparyId }
              }"
              >查看 </router-link
            >&nbsp;
            <router-link
              v-if="operationSuper.编辑"
              :to="{
                path: '/baseComparyEdit',
                query: {
                  pageType: '2',
                  id: scope.row.comparyId,
                  provinceId: scope.row.provinceId
                }
              }"
              >编辑</router-link
            >&nbsp;
            <el-button
              v-if="operationSuper.删除"
              @click="deleteRow(scope)"
              type="text"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
  </div>
</template>

<script>
import { FetchGetArea } from "@/api/public";
import { DeletComparyInfoByIds, getDictByDicTypeKey } from "@/api/base/compary";
import { mapActions } from "vuex";
import { mergeFormExtend } from "_private/utils/merge";
import listInit from "@/mixins/listInit";
import operationManage from "_private/mixins/operationManage";
import e6City from "e6city";

export default {
  components: { e6City },
  mixins: [listInit, operationManage],
  data() {
    return {
      isSearch: false,
      formExtend: {
        forms: {
          provinceName: "",
          provinceId: "",
          cityName: "",
          cityId: "",
          countyName: "",
          countyId: "",
          comparyName: "",
          comparyTypeId: "",
          regisArea: "",
          userTypeList: [],
          corpCategoryList: []
        },
        extends: []
      },
      formsExtend: [],
      columSetVisible: false,
      multipleSelection: [],
      provinceList: [],
      cityList: [],
      optionMap: {},
      countyList: [],
      corpCategoryList: [],
      roleAttributeList: [
        {
          id: 0,
          label: "企业"
        },
        {
          id: 20,
          label: "消毒机构"
        },
        {
          id: 30,
          label: "检验机构"
        },
        {
          id: 40,
          label: "政府部门"
        },
        {
          id: 50,
          label: "测试"
        }
      ],
      messageBoxVisible: false,
      analysisError: false,
      aErrorDatas: [],
      errMess: "",
      tableLoading: "false",
      // 请求表格数据
      tableDataUrl: "/base/compary/findByPage",
      //导出URL
      exportUrl: "/base/compary/exportComparyList?"
    };
  },
  created() {
    this.FetchGetArea(0, 1, 1);
    this.setSearchFormIsOpenAct();
    this.getDictByDicTypeKey();
    this.initPage();
    //
  },

  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 根据父级获取地区下拉框
    FetchGetArea(parentId, type, num) {
      FetchGetArea(parentId, type)
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            if (num == 1) {
              this.provinceList = response.result;
            } else if (num == 2) {
              this.cityList = response.result;
            } else if (num == 3) {
              this.countyList = response.result;
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    citySelect(res) {
      if (res.province.name == "澳门") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else if (res.province.name == "香港") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else if (res.province.name == "台湾省") {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.province.name;
      } else {
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.city.name;
        this.formExtend.forms.countyName = res.district.name;
      }
    },
    async getDictByDicTypeKey() {
      const res = await getDictByDicTypeKey({
        dicTypeKey: "corp_category"
      });
      console.log(res);
      this.corpCategoryList = res.result;
    },
    //省选择事件
    provinceChange() {
      this.cityList = [];
      this.countyList = [];
      this.formExtend.forms.cityId = "";
      this.formExtend.forms.cityName = "";
      this.formExtend.forms.countyName = "";
      try {
        this.provinceList.forEach(item => {
          if (this.formExtend.forms.provinceId == item.id) {
            this.formExtend.forms.provinceName = item.name;
            throw Error();
          } else {
            this.formExtend.forms.provinceName = "";
          }
        });
      } catch (e) {
        console.log(e);
      }

      this.FetchGetArea(this.formExtend.forms.provinceId, 2, 2);
    },
    //市选择事件
    cityChange() {
      this.coutyList = [];
      this.formExtend.forms.countyName = "";
      try {
        this.cityList.forEach(item => {
          if (this.formExtend.forms.cityId == item.id) {
            this.formExtend.forms.cityName = item.name;
            throw Error();
          } else {
            this.formExtend.forms.cityName = "";
          }
        });
      } catch (e) {
        console.log(e);
      }

      this.FetchGetArea(this.formExtend.forms.cityId, 3, 3);
    },
    // 删除行
    deleteRow({ row }) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.tableLoading = true;

          const { code, message } = await DeletComparyInfoByIds({
            ids: row.comparyId
          });

          this.tableLoading = false;

          if (code === 1) {
            this.successMessage("删除成功", () => {
              this.handleCurrentChange(1);
            });
          } else {
            this.errorMessage(message || "删除失败，请重试");
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        curPage: this.curPage,
        pageSize: this.pageSize
      });
    },
    //重置
    handleResetForm() {
      this.formExtend.forms.cityId = "";
      this.formExtend.forms.provinceId = "";
      this.formExtend.forms.countyName = "";
      this.formExtend.forms.cityName = "";
      this.formExtend.forms.provinceName = "";
      // this.$refs.e6City.clearCity();
    },
    handleExportClick() {
      let param = "";
      param += "&comparyName=" + this.formExtend.forms.comparyName;
      param += "&comparyTypeId=" + this.formExtend.forms.comparyTypeId;
      param += "&provinceName=" + this.formExtend.forms.provinceName;
      param += "&cityName=" + this.formExtend.forms.cityName;
      param += "&countyName=" + this.formExtend.forms.countyName;
      document.location.href = this.exportUrl + param;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
</style>
